<div class="profile-container">
  <a [routerLink]="backLink" class="back-link">
    <span class="material-icons">keyboard_backspace</span> {{ backLabel }}
  </a>
  <div class="profile-header">
    <h1>Your Profile</h1>
    <p>
      {{
      isIndividual
      ? "Manage your account settings"
      : "Manage your account settings and company
      details"
      }}
    </p>
  </div>

  <div *ngIf="!isLoading" class="profile-content">
    <!-- User Details Section -->
    <div class="section-card">
      <h2>Personal Information</h2>
      <div class="form-grid">
        <div class="custom-input-box">
          <span class="label-tiny">First Name</span>
          <input [(ngModel)]="firstname" placeholder="Enter your name" />
        </div>

        <div class="custom-input-box">
          <span class="label-tiny">Email (Cannot be changed)</span>
          <input [value]="email" disabled />
        </div>

        <div class="phone-row">
          <div class="custom-input-box country-select">
            <mat-select [(ngModel)]="countryCode" name="countryCode" panelClass="wide-country-dropdown"
              disableOptionCentering>
              <mat-select-trigger>
                <div class="flex-center" *ngIf="getSelectedCountry() as selected">
                  <img [src]="selected.flag" class="flag-icon-small" />
                  {{ selected.code }}
                </div>
              </mat-select-trigger>
              <mat-option *ngFor="let c of countryList" [value]="c.code">
                <img [src]="c.flag" class="flag-icon" />
                {{ c.name }} ({{ c.code }})
              </mat-option>
            </mat-select>
          </div>

          <div class="custom-input-box phone-input">
            <span class="label-tiny">Phone Number</span>
            <input [(ngModel)]="phoneNumber" placeholder="Enter phone number" [maxlength]="currentPhoneLimit"
              (keypress)="numberOnly($event)" />
          </div>
        </div>

        <div class="phone-row" *ngIf="!isVisiting">
          <div class="custom-input-box country-select">
            <mat-select [(ngModel)]="telephoneCountryCode" name="telephoneCountryCode"
              panelClass="wide-country-dropdown" disableOptionCentering>
              <mat-select-trigger>
                <div class="flex-center" *ngIf="getSelectedTelephoneCountry() as selected">
                  <img [src]="selected.flag" class="flag-icon-small" />
                  {{ selected.code }}
                </div>
              </mat-select-trigger>
              <mat-option *ngFor="let c of countryList" [value]="c.code">
                <img [src]="c.flag" class="flag-icon" />
                {{ c.name }} ({{ c.code }})
              </mat-option>
            </mat-select>
          </div>

          <div class="custom-input-box phone-input">
            <span class="label-tiny">Telephone (Optional)</span>
            <input [(ngModel)]="telephone" placeholder="Enter telephone" [maxlength]="currentPhoneLimit"
              (keypress)="numberOnly($event)" />
          </div>
        </div>
      </div>
    </div>

    <!-- Company Details Section -->
    <div class="section-card" *ngIf="!isIndividual">
      <h2>Company Details</h2>
      <div class="company-logo-wrapper">
        <div class="logo-preview" [style.backgroundImage]="getProfileImageStyle()">
          <!-- Removed Overlay as requested -->
        </div>
        <input type="file" id="logoInput" (change)="onLogoSelected($event)" accept="image/*" hidden />
        <div class="logo-info">
          <!-- Removed Heading as requested -->
          <p>Upload a clear PNG or JPG logo.</p>

          <div class="logo-actions" style="display: flex; gap: 10px; margin-top: 8px">
            <!-- EDIT / UPLOAD BUTTON -->
            <button mat-stroked-button color="primary" (click)="triggerFileInput()">
              <mat-icon>{{ companyLogoUrl ? "edit" : "upload" }}</mat-icon>
              {{ companyLogoUrl ? "Edit Logo" : "Upload Logo" }}
            </button>

            <!-- DELETE BUTTON (Only if logo exists) -->
            <button *ngIf="companyLogoUrl" mat-stroked-button color="primary" (click)="deleteLogo()">
              <mat-icon>close</mat-icon> Remove
            </button>
          </div>
        </div>
      </div>

      <div class="form-grid mt-20">
        <div class="custom-input-box">
          <span class="label-tiny">Company Name</span>
          <input [(ngModel)]="companyName" placeholder="Enter company name" />
        </div>

        <div class="custom-input-box full-width">
          <span class="label-tiny">Company Address</span>
          <textarea [(ngModel)]="companyAddress" rows="2" placeholder="Enter company address"></textarea>
        </div>

        <div class="custom-input-box">
          <span class="label-tiny">Company Tagline</span>
          <input [(ngModel)]="tagline" placeholder="e.g. Construct • Deliver • Excel" />
        </div>

        <div class="custom-input-box">
          <span class="label-tiny">Company Website</span>
          <input [(ngModel)]="website" placeholder="e.g. www.buildcore.in" />
        </div>

        <div class="custom-input-box">
          <span class="label-tiny">Fax Number</span>
          <input [(ngModel)]="fax" placeholder="e.g. +971 4 123 4568" />
        </div>
      </div>

      <!-- Business License Section -->
      <div class="form-grid mt-20" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px">
        <div class="custom-input-box">
          <span class="label-tiny">
            Business License No.
            <mat-icon *ngIf="tradeLicenseVerified" style="color: #1976d2; font-size: 18px; vertical-align: middle;">verified</mat-icon>
          </span>
          <input [(ngModel)]="businessLicenseNo" placeholder="TRD-XXXXX" />
        </div>

        <div class="custom-input-box">
          <span class="label-tiny">TRN Number</span>
          <input [(ngModel)]="trnNumber" placeholder="e.g. 100xxxxxxxxxxxx" />
        </div>

        <div class="custom-input-box date-picker-box">
          <span class="label-tiny">License Valid Till</span>
          <div style="display: flex; align-items: center">
            <input [matDatepicker]="picker" [(ngModel)]="licenseValidTill" placeholder="DD/MM/YYYY"
              style="flex: 1; border: none; outline: none" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>

        <div class="custom-input-box">
          <span class="label-tiny">License Issued By</span>
          <input [(ngModel)]="licenseIssuedBy" placeholder="e.g. DED Dubai" />
        </div>
      </div>
    </div>

    <!-- Company Documents Section -->
    <div class="section-card" *ngIf="!isIndividual">
      <div class="card-header-row">
        <h2>Company Documents</h2>
        <button mat-stroked-button color="primary" (click)="triggerDocUpload()" [disabled]="isUploadingDoc">
          <mat-icon *ngIf="!isUploadingDoc">cloud_upload</mat-icon>
          <mat-spinner *ngIf="isUploadingDoc" diameter="20" style="
              display: inline-block;
              vertical-align: middle;
              margin-right: 5px;
            "></mat-spinner>
          {{ isUploadingDoc ? "Uploading..." : "Upload Document" }}
        </button>
        <input type="file" id="docInput" (change)="onDocSelected($event)" accept=".pdf, .jpg, .jpeg, .png, .doc, .docx"
          hidden />
      </div>

      <!-- Images Section -->
      <div class="docs-section mt-3" *ngIf="imageDocuments.length > 0">
        <h5 class="section-subtitle">Images</h5>
        <div class="docs-list">
          <div class="doc-item" *ngFor="let doc of imageDocuments; let i = index">
            <div class="doc-icon">
              <mat-icon>image</mat-icon>
            </div>
            <div class="doc-info">
              <h4>{{ doc.name }}</h4>
              <span>Saved on
                {{
                doc.savedAt?.toDate
                ? (doc.savedAt.toDate() | date: "mediumDate")
                : (doc.savedAt | date: "mediumDate")
                }}</span>
            </div>
            <div class="doc-actions">
              <button mat-icon-button color="primary" (click)="viewDocument(doc)">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteDocument(doc, companyDocuments.indexOf(doc))">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- PDF Documents Section -->
      <div class="docs-section mt-4" *ngIf="pdfDocuments.length > 0">
        <h5 class="section-subtitle">PDF Documents</h5>
        <div class="docs-list">
          <div class="doc-item" *ngFor="let doc of pdfDocuments; let i = index">
            <div class="doc-icon pdf">
              <mat-icon>picture_as_pdf</mat-icon>
            </div>
            <div class="doc-info">
              <h4>{{ doc.name }}</h4>
              <span>Saved on {{ doc.savedAt | date: "mediumDate" }}</span>
            </div>
            <div class="doc-actions">
              <button mat-icon-button color="primary" (click)="viewDocument(doc)" matTooltip="View">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteDocument(doc, i)" matTooltip="Delete">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Word Documents Section -->
      <div class="docs-section mt-4" *ngIf="docDocuments.length > 0">
        <h5 class="section-subtitle">Word Documents</h5>
        <div class="docs-list">
          <div class="doc-item" *ngFor="let doc of docDocuments; let i = index">
            <div class="doc-icon doc">
              <mat-icon>description</mat-icon>
            </div>
            <div class="doc-info">
              <h4>{{ doc.name }}</h4>
              <span>Saved on {{ doc.savedAt | date: "mediumDate" }}</span>
            </div>
            <div class="doc-actions">
              <button mat-icon-button color="primary" (click)="viewDocument(doc)" matTooltip="View">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteDocument(doc, i)" matTooltip="Delete">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="empty-docs" *ngIf="companyDocuments.length === 0">
        <mat-icon>folder_open</mat-icon>
        <p>No documents uploaded yet.</p>
      </div>
    </div>

    <!-- Purchase Order Template Section (CUSTOMERS ONLY) -->
    <div class="section-card" *ngIf="role === 'customer' && !isIndividual">
      <div class="section-header-row" style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        ">
        <div>
          <h2>Purchase Order (LPO) Templates</h2>
          <p class="subtitle" style="margin: 0">
            Create and manage multiple LPO templates. The selected template will
            be used for orders.
          </p>
        </div>
        <div class="header-actions">
          <button mat-stroked-button color="primary" (click)="openLpoTemplateDialog()" style="margin-right: 8px">
            <mat-icon>add</mat-icon> Add Template
          </button>
        </div>
      </div>

      <!-- Templates Grid -->
      <div class="templates-grid" *ngIf="lpoTemplates.length > 0">
        <div class="template-mini-card" *ngFor="let t of lpoTemplates; let i = index"
          [class.selected]="i === selectedLpoIndex" (click)="selectLpoTemplate(i)">
          <div class="mini-content">
            <!-- Top Section: Company Info ONLY (No Logo) -->
            <div class="doc-top-section">
              <div class="doc-company-info">
                <strong>{{ companyName }}</strong>
                <div *ngIf="phoneNumber">{{ phoneNumber }}</div>
              </div>
              <div class="doc-title">PURCHASE ORDER</div>
            </div>
            <div class="doc-body">
              <div class="doc-table-header">
                <span>Item</span><span>Qty</span><span>Price</span><span>Total</span>
              </div>
              <div class="doc-table-row">
                <span>Item A</span><span>10</span><span>100</span><span>1000</span>
              </div>
              <div class="doc-table-row">
                <span>Item B</span><span>5</span><span>50</span><span>250</span>
              </div>
              <div class="doc-table-total">
                <span>Total: 1250</span>
              </div>
            </div>

            <!-- Terms Section -->
            <div class="doc-terms" *ngIf="t.terms">
              <strong>Terms:</strong>
              <div class="terms-text" [innerHTML]="t.terms | slice: 0 : 100"></div>
            </div>

            <!-- Bottom Section: Signature & Footer -->
            <div class="doc-bottom-section">
              <div class="doc-signature" *ngIf="t.signatureUrl">
                <img [src]="t.signatureUrl" alt="Sig" />
                <span>Authorized Signature</span>
              </div>
              <div class="doc-footer" *ngIf="t.footer">
                {{ t.footer | slice: 0 : 50 }}
              </div>
            </div>

            <!-- Selection Indicator (Overlay) -->
            <div class="selection-indicator">
              <mat-icon>check_circle</mat-icon>
            </div>

            <!-- Action Buttons (Hover) -->
            <div class="card-actions">
              <button mat-icon-button class="action-btn preview-btn"
                (click)="previewSampleLpo(i); $event.stopPropagation()" matTooltip="Preview Sample LPO">
                <mat-icon>remove_red_eye</mat-icon>
              </button>
              <button mat-icon-button class="action-btn view-btn"
                (click)="openLpoTemplateDialog(i); $event.stopPropagation()" matTooltip="Edit Template">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="action-btn delete-btn"
                (click)="deleteLpoTemplate(i); $event.stopPropagation()" matTooltip="Delete">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <div class="template-name">{{ t.name || "Template " + (i + 1) }}</div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="lpoTemplates.length === 0" class="empty-state" style="
          text-align: center;
          color: #888;
          padding: 40px;
          background: #f8f9fa;
          border-radius: 8px;
          border: 1px dashed #ddd;
        ">
        <mat-icon style="
            font-size: 48px;
            height: 48px;
            width: 48px;
            opacity: 0.5;
            margin-bottom: 12px;
          ">description</mat-icon>
        <p>No LPO templates created yet.</p>
        <div style="display: flex; gap: 10px; justify-content: center">
          <button mat-raised-button color="primary" (click)="openLpoTemplateDialog()">
            <mat-icon>add</mat-icon> Create Custom Template
          </button>
        </div>
      </div>
    </div>

    <!-- Time Sheet Template Section (VENDORS/BUSINESS ONLY) -->
    <!-- <div class="section-card" *ngIf="role === 'business'">
      <div
        class="section-header-row"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        "
      >
        <div>
          <h2>Time Sheet Template</h2>
          <p class="subtitle" style="margin: 0">
            Configure how your Time Sheets look.
          </p>
        </div>
        <button
          mat-raised-button
          color="primary"
          (click)="openTimeSheetTemplateDialog()"
        >
          <mat-icon>edit</mat-icon> Edit Template
        </button>
      </div>

      <div
        class="template-preview-card"
        style="
          background: #f8f9fa;
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 20px;
        "
      >
        <div
          *ngIf="!timeSheetTemplateHeader && !timeSheetTemplateTerms"
          class="empty-state"
          style="text-align: center; color: #888; padding: 20px"
        >
          <mat-icon
            style="font-size: 48px; height: 48px; width: 48px; opacity: 0.5"
            >schedule</mat-icon
          >
          <p>No Time Sheet template configured yet.</p>
          <button
            mat-button
            color="primary"
            (click)="openTimeSheetTemplateDialog()"
          >
            Create Template
          </button>
        </div>

        <div
          *ngIf="timeSheetTemplateHeader || timeSheetTemplateTerms"
          class="preview-content"
        >

          <div class="preview-company" style="margin-bottom: 15px">
            <span
              style="
                font-size: 10px;
                text-transform: uppercase;
                color: #888;
                letter-spacing: 1px;
              "
              >Company Info Used</span
            >
            <p style="margin: 5px 0">
              <strong>{{ companyName || "(No Company Name)" }}</strong
              ><br />
              {{ phoneNumber }}
            </p>
          </div>

          <div class="preview-terms">
            <span
              style="
                font-size: 10px;
                text-transform: uppercase;
                color: #888;
                letter-spacing: 1px;
              "
              >Terms Snippet</span
            >
            <p
              style="
                margin: 5px 0;
                color: #555;
                font-size: 13px;
                white-space: pre-wrap;
              "
            >
              {{ timeSheetTemplateTerms | slice: 0 : 100
              }}{{ timeSheetTemplateTerms.length > 100 ? "..." : "" }}
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Quotation Branding Section (VENDORS/BUSINESS ONLY) -->
    <!-- <div class="section-card" *ngIf="role === 'business'">
      <h2>Quotation Branding</h2>
      <p class="subtitle">Upload a PDF letterhead to use as background for generated quotations.</p>

      <div *ngIf="isProcessingLetterhead" class="letterhead-processing-banner"
        style="display:flex;align-items:center;gap:10px;padding:10px 14px;margin-bottom:16px;background:#eef2ff;border:1px solid #c7d2fe;border-radius:8px;max-width:480px;">
        <mat-spinner diameter="18"></mat-spinner>
        <span style="font-size:13px;color:#3730a3;">Converting your letterhead — this updates automatically, no need to
          refresh.</span>
      </div>

      <div *ngIf="quotationBranding" class="doc-item" style="max-width: 480px; margin-bottom: 16px;">
        <div class="doc-icon pdf">
          <mat-icon>picture_as_pdf</mat-icon>
        </div>
        <div class="doc-info">
          <h4>{{ quotationBranding.fileName }}</h4>
          <span>Uploaded {{ quotationBranding.uploadedAt?.toDate ? (quotationBranding.uploadedAt.toDate() |
            date:'mediumDate') : (quotationBranding.uploadedAt | date:'mediumDate') }}</span>
        </div>
        <div class="doc-actions">
          <button mat-icon-button color="primary" (click)="triggerLetterheadUpload()" matTooltip="Replace">
            <mat-icon>swap_horiz</mat-icon>
          </button>
          <a mat-icon-button color="primary" [href]="quotationBranding.letterheadUrl" target="_blank"
            matTooltip="Preview">
            <mat-icon>visibility</mat-icon>
          </a>
          <button mat-icon-button color="warn" (click)="deleteLetterhead()" matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="!quotationBranding">
        <button mat-stroked-button color="primary" (click)="triggerLetterheadUpload()"
          [disabled]="isUploadingLetterhead">
          <mat-icon *ngIf="!isUploadingLetterhead">upload</mat-icon>
          <mat-spinner *ngIf="isUploadingLetterhead" diameter="20"
            style="display:inline-block;vertical-align:middle;margin-right:5px;"></mat-spinner>
          {{ isUploadingLetterhead ? 'Uploading...' : 'Upload Letterhead (PDF)' }}
        </button>
      </div>

      <input type="file" id="letterheadInput" (change)="onLetterheadSelected($event)" accept="application/pdf" hidden />
    </div>

    <!-- Quotation Header & Footer Branding (VENDORS/BUSINESS ONLY) -->
    <div class="section-card" *ngIf="role === 'business'">
      <div
        style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px; margin-bottom: 20px;">
        <div>
          <h2>Document Branding Settings</h2>
          <p class="subtitle">Upload high-resolution header and footer images to brand your generated quotations. Click
            on either preview below to edit details.</p>
        </div>
      </div>

      <div class="branding-upload-stack" style="display: flex; flex-direction: column; gap: 24px;">
        <!-- Header Card (Clickable Preview) -->
        <div class="branding-card clickable-preview-card" (click)="openBrandingEditorDialog('header')"
          style="border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; background: #f8fafc; display: flex; flex-direction: column; gap: 16px; cursor: pointer; position: relative; transition: all 0.2s ease-in-out;">
          <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
            <h3
              style="margin: 0; font-size: 16px; font-weight: 600; color: #1e293b; display: flex; align-items: center; gap: 8px;">
              <span>Quotation Header Preview</span>
              <span
                style="font-size: 11px; padding: 2px 8px; background: rgba(37, 99, 235, 0.1); color: #2563eb; border-radius: 6px; font-weight: 500; display: inline-flex; align-items: center; gap: 4px;">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px;">edit</mat-icon> Click to Customize
              </span>
            </h3>
            <span style="font-size: 12px; color: #64748b; font-weight: 500;">Recommended Size: 2480 x 350 px (Aspect
              ratio ~7:1)</span>
          </div>

          <div class="image-preview-box canvas-container"
            style="aspect-ratio: 2480 / 350; width: 100%; border: 1px dashed #cbd5e1; border-radius: 8px; background: #fff; display: flex; align-items: center; justify-content: center; overflow: hidden; position: relative; pointer-events: none;">
            <img *ngIf="quotationBranding?.headerImageUrl || quotationBranding?.headerBase64"
              [src]="quotationBranding?.headerBase64 || quotationBranding?.headerImageUrl"
              style="width: 100% !important; height: 100% !important; object-fit: fill !important; max-width: none !important; max-height: none !important; position: absolute; top:0; left:0; z-index:1;" />
            <div *ngIf="!(quotationBranding?.headerImageUrl || quotationBranding?.headerBase64)"
              style="color: #94a3b8; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; z-index:2;">
              <mat-icon style="font-size: 32px; height: 32px; width: 32px;">image</mat-icon>
              <span style="font-size: 13px;">No header uploaded</span>
            </div>

            <!-- Header Text & Logo Overlay on Canvas (Read-Only Preview) -->
            <ng-container
              *ngIf="quotationBranding && (quotationBranding.headerImageUrl || quotationBranding.headerBase64)">
              <!-- Logo overlay -->
              <div class="canvas-logo-overlay" [style.left.%]="quotationBranding.headerLogoLeft"
                [style.top.%]="quotationBranding.headerLogoTop" [style.width.%]="quotationBranding.headerLogoWidth"
                [style.height.%]="quotationBranding.headerLogoHeight">
                <img [src]="companyLogoUrl || 'assets/images/default-logo.png'" alt="Logo" class="canvas-logo-img" />
              </div>

              <!-- Company Name overlay -->
              <div class="canvas-text-overlay name-overlay" [style.left.%]="quotationBranding.headerNameLeft"
                [style.top.%]="quotationBranding.headerNameTop">
                <span class="name-text">{{ companyName || 'Enter Company Name' }}</span>
              </div>

              <!-- Tagline overlay -->
              <div class="canvas-text-overlay tagline-overlay" [style.left.%]="quotationBranding.headerTaglineLeft"
                [style.top.%]="quotationBranding.headerTaglineTop">
                <span class="tagline-text">{{ tagline || 'Enter Tagline (Optional)' }}</span>
              </div>

              <!-- Contact block overlay -->
              <div class="canvas-contact-overlay" [style.left.%]="quotationBranding.headerContactLeft"
                [style.top.%]="quotationBranding.headerContactTop"
                [style.width.%]="quotationBranding.headerContactWidth"
                [style.--theme-color]="quotationBranding.themeColor || '#ffffff'">
                <div class="canvas-contact-row" *ngIf="companyAddress">
                  <i class="fa-solid fa-location-dot contact-icon"></i>
                  <span class="contact-text">{{ companyAddress }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="phoneNumber">
                  <i class="fa-solid fa-phone contact-icon"></i>
                  <span class="contact-text">{{ phoneNumber }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="fax">
                  <i class="fa-solid fa-fax contact-icon"></i>
                  <span class="contact-text">{{ fax }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="email">
                  <i class="fa-solid fa-envelope contact-icon"></i>
                  <span class="contact-text">{{ email }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="website">
                  <i class="fa-solid fa-globe contact-icon"></i>
                  <span class="contact-text">{{ website }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Footer Card (Clickable Preview) -->
        <div class="branding-card clickable-preview-card" (click)="openBrandingEditorDialog('footer')"
          style="border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; background: #f8fafc; display: flex; flex-direction: column; gap: 16px; cursor: pointer; position: relative; transition: all 0.2s ease-in-out;">
          <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
            <h3
              style="margin: 0; font-size: 16px; font-weight: 600; color: #1e293b; display: flex; align-items: center; gap: 8px;">
              <span>Quotation Footer Preview</span>
              <span
                style="font-size: 11px; padding: 2px 8px; background: rgba(37, 99, 235, 0.1); color: #2563eb; border-radius: 6px; font-weight: 500; display: inline-flex; align-items: center; gap: 4px;">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px;">edit</mat-icon> Click to Customize
              </span>
            </h3>
            <span style="font-size: 12px; color: #64748b; font-weight: 500;">Recommended Size: 2480 x 200 px (Aspect
              ratio ~12:1)</span>
          </div>

          <div class="image-preview-box canvas-container"
            style="aspect-ratio: 2480 / 350; width: 100%; border: 1px dashed #cbd5e1; border-radius: 8px; background: #fff; display: flex; align-items: center; justify-content: center; overflow: hidden; position: relative; pointer-events: none;">
            <img *ngIf="quotationBranding?.footerImageUrl || quotationBranding?.footerBase64"
              [src]="quotationBranding?.footerBase64 || quotationBranding?.footerImageUrl"
              style="width: 100% !important; height: 100% !important; object-fit: fill !important; max-width: none !important; max-height: none !important; position: absolute; top:0; left:0; z-index:1;" />
            <div *ngIf="!(quotationBranding?.footerImageUrl || quotationBranding?.footerBase64)"
              style="color: #94a3b8; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; z-index:2;">
              <mat-icon style="font-size: 32px; height: 32px; width: 32px;">image</mat-icon>
              <span style="font-size: 13px;">No footer uploaded</span>
            </div>

            <!-- Footer Contact Block Overlay (Read-Only Preview) - Commented out
            <ng-container
              *ngIf="quotationBranding && (quotationBranding.footerImageUrl || quotationBranding.footerBase64)">
              <div class="canvas-footer-contact-overlay" [style.left.%]="quotationBranding.footerContactLeft"
                [style.top.%]="quotationBranding.footerContactTop"
                [style.width.%]="quotationBranding.footerContactWidth || 45"
                [style.--theme-color]="quotationBranding.themeColor || '#ffffff'">
                <div class="canvas-contact-row" *ngIf="companyAddress">
                  <i class="fa-solid fa-location-dot contact-icon"></i>
                  <span class="contact-text">{{ companyAddress }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="phoneNumber">
                  <i class="fa-solid fa-phone contact-icon"></i>
                  <span class="contact-text">{{ phoneNumber }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="fax">
                  <i class="fa-solid fa-fax contact-icon"></i>
                  <span class="contact-text">{{ fax }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="email">
                  <i class="fa-solid fa-envelope contact-icon"></i>
                  <span class="contact-text">{{ email }}</span>
                </div>
                <div class="canvas-contact-row" *ngIf="website">
                  <i class="fa-solid fa-globe contact-icon"></i>
                  <span class="contact-text">{{ website }}</span>
                </div>
              </div>
            </ng-container> -->
          </div>
        </div>
      </div>
    </div>

    <!-- ── Worker Management Section (VENDOR ONLY) ── -->
    <div class="section-card worker-management-card" *ngIf="role === 'business'">
      <div class="worker-header-row">
        <div class="worker-header-left">
          <div>
            <h2>Workers {{ workers.length }} / {{ workerSettings.defaultWorkerLimit }}</h2>
            <p class="worker-subtitle">Workers have full vendor dashboard access but cannot modify company settings or
              create other workers.</p>
          </div>
        </div>
        <button class="worker-add-btn"
          [disabled]="!workerSettings.enabled || (workers.length >= workerSettings.defaultWorkerLimit && !showAddWorkerForm)"
          [style.opacity]="(!workerSettings.enabled || (workers.length >= workerSettings.defaultWorkerLimit && !showAddWorkerForm)) ? 0.6 : 1"
          [style.cursor]="(!workerSettings.enabled || (workers.length >= workerSettings.defaultWorkerLimit && !showAddWorkerForm)) ? 'not-allowed' : 'pointer'"
          [matTooltip]="!workerSettings.enabled ? 'Worker Management is disabled globally.' : (workers.length >= workerSettings.defaultWorkerLimit && !showAddWorkerForm ? 'Maximum of ' + workerSettings.defaultWorkerLimit + ' workers allowed.' : '')"
          (click)="(!workerSettings.enabled || (workers.length >= workerSettings.defaultWorkerLimit && !showAddWorkerForm)) ? $event.stopPropagation() : toggleAddWorkerForm()">
          <i class="fa-solid" [class.fa-plus]="!showAddWorkerForm" [class.fa-xmark]="showAddWorkerForm"></i>
          {{ showAddWorkerForm ? 'Cancel' : 'Add Worker' }}
        </button>
      </div>

      <!-- Add Worker Form -->
      <div class="worker-form-panel" *ngIf="showAddWorkerForm">
        <div class="worker-form-grid">
          <div class="custom-input-box">
            <span class="label-tiny">Worker Name</span>
            <input [(ngModel)]="workerForm.name" placeholder="e.g. Ahmed Al-Rashid" />
          </div>
          <div class="custom-input-box">
            <span class="label-tiny">Worker Email</span>
            <input [(ngModel)]="workerForm.email" type="email" placeholder="e.g. ahmed@company.com" />
          </div>
          <div class="custom-input-box">
            <span class="label-tiny">Set Password</span>
            <input [(ngModel)]="workerForm.password" type="password" placeholder="Min. 6 characters" />
          </div>
        </div>
        <div class="worker-form-actions">
          <p class="worker-form-note">
            <i class="fa-solid fa-circle-info"></i>
            Share this email &amp; password with the worker. They will log in using the standard login page.
          </p>
          <button class="worker-create-btn" (click)="createWorker()" [disabled]="isCreatingWorker">
            <i class="fa-solid fa-user-plus"></i>
            {{ isCreatingWorker ? 'Creating...' : 'Create Worker Account' }}
          </button>
        </div>
      </div>

      <!-- Workers List -->
      <div *ngIf="isLoadingWorkers" class="worker-loading">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Loading workers...</span>
      </div>

      <div class="workers-list" *ngIf="!isLoadingWorkers">
        <div class="worker-empty" *ngIf="workers.length === 0">
          <i class="fa-solid fa-user-slash"></i>
          <p>No workers added yet. Click "Add Worker" to get started.</p>
        </div>

        <div class="worker-item" *ngFor="let w of workers">
          <div class="worker-avatar">{{ (w.firstname || w.email || 'W').charAt(0).toUpperCase() }}</div>
          <div class="worker-info">
            <div class="worker-name">{{ w.firstname || 'Worker' }}</div>
            <div class="worker-email">{{ w.email }}</div>
            <div class="worker-meta">
              <span class="worker-pass-badge">
                <i class="fa-solid fa-key"></i> {{ w.passwordText || '••••••' }}
              </span>
              <span class="worker-date" *ngIf="w.createdAt">
                Added {{ w.createdAt | date:'mediumDate' }}
              </span>
            </div>
          </div>
          <div class="worker-actions">
            <button class="worker-action-btn pwd-btn" (click)="changeWorkerPassword(w)" matTooltip="Change Password">
              <i class="fa-solid fa-key"></i>
            </button>
            <button class="worker-action-btn del-btn" (click)="deleteWorker(w)" matTooltip="Remove Worker">
              <i class="fa-solid fa-user-minus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="actions-bar">
      <button mat-raised-button color="primary" (click)="saveProfile()" [disabled]="isSaving" class="save-btn">
        Save Changes
      </button>
    </div>
  </div>
</div>

<!-- Interactive Visual Branding Template Editor Dialog Modal -->
<ng-template #brandingEditorDialog let-dialogRef="dialogRef">
  <div class="branding-dialog-wrapper"
    style="padding: 24px; display: flex; flex-direction: column; gap: 20px; outline: none; background: #ffffff; border-radius: 12px; max-width: 100%; box-sizing: border-box;">

    <div
      style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e2e8f0; padding-bottom: 16px;">
      <div>
        <h2 style="margin: 0; font-size: 18px; font-weight: 700; color: #0f172a;"> {{ activeEditorType === 'header' ?
          'Header' : 'Footer' }} Canvas Editor</h2>
        <p style="margin: 4px 0 0 0; font-size: 12px; color: #64748b;">Click on any dynamic text or logo directly on the
          {{ activeEditorType === 'header' ? 'header' : 'footer' }} background canvas below to edit inline.</p>
      </div>
      <button mat-icon-button type="button" (click)="dialogRef.close()" style="color: #64748b;">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="branding-upload-stack"
      style="display: flex; flex-direction: column; gap: 24px; max-height: 65vh; overflow-y: auto; padding: 4px;">
      <!-- Header Upload Card -->
      <div class="branding-card" *ngIf="activeEditorType === 'header'"
        style="border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; background: #f8fafc; display: flex; flex-direction: column; gap: 16px;">
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
          <h3 style="margin: 0; font-size: 15px; font-weight: 600; color: #1e293b;">Quotation Header</h3>
          <span style="font-size: 11px; color: #64748b; font-weight: 500;">Recommended Size: 2480 x 350 px (Aspect ratio
            ~7:1)</span>
        </div>

        <div class="image-preview-box canvas-container"
          style="aspect-ratio: 2480 / 350; width: 100%; border: 1px dashed #cbd5e1; border-radius: 8px; background: #fff; display: flex; align-items: center; justify-content: center; overflow: hidden; position: relative;">
          <img *ngIf="quotationBranding?.headerImageUrl || quotationBranding?.headerBase64"
            [src]="quotationBranding?.headerBase64 || quotationBranding?.headerImageUrl"
            style="width: 100% !important; height: 100% !important; object-fit: fill !important; max-width: none !important; max-height: none !important; position: absolute; top:0; left:0; z-index:1;" />
          <div *ngIf="!(quotationBranding?.headerImageUrl || quotationBranding?.headerBase64)"
            style="color: #94a3b8; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; z-index:2;">
            <mat-icon style="font-size: 32px; height: 32px; width: 32px;">image</mat-icon>
            <span style="font-size: 13px;">No header uploaded</span>
          </div>

          <!-- Header Text & Logo Overlay on Canvas -->
          <ng-container
            *ngIf="quotationBranding && (quotationBranding.headerImageUrl || quotationBranding.headerBase64)">
            <!-- Logo overlay -->
            <div class="canvas-logo-overlay" [style.left.%]="quotationBranding.headerLogoLeft"
              [style.top.%]="quotationBranding.headerLogoTop" [style.width.%]="quotationBranding.headerLogoWidth"
              [style.height.%]="quotationBranding.headerLogoHeight">
              <img [src]="companyLogoUrl || 'assets/images/default-logo.png'" alt="Logo" class="canvas-logo-img"
                (click)="showLogoOptions = !showLogoOptions" />
              <div class="logo-actions-popover" *ngIf="showLogoOptions">
                <div class="popover-arrow"></div>
                <button type="button" class="popover-btn" (click)="triggerFileInput(); showLogoOptions = false;"><i
                    class="fa-solid fa-arrow-up-from-bracket"></i> Replace Logo</button>
                <button type="button" class="popover-btn delete-btn" (click)="deleteLogo(); showLogoOptions = false;"><i
                    class="fa-solid fa-trash-can"></i> Remove Logo</button>
              </div>
            </div>

            <!-- Company Name + Tagline overlay (grouped for vertical centering) -->
            <div class="canvas-text-overlay name-overlay" [style.left.%]="quotationBranding.headerNameLeft"
              style="top: 50%;">
              <span *ngIf="!editingCanvasName" (click)="editingCanvasName = true"
                class="canvas-clickable-text name-text">{{ companyName || 'Enter Company Name' }}</span>
              <input *ngIf="editingCanvasName" type="text" [(ngModel)]="companyName" (blur)="editingCanvasName = false"
                (keyup.enter)="editingCanvasName = false" autofocus class="canvas-inline-input name-input" />
              <div class="tagline-row">
                <span *ngIf="!editingCanvasTagline" (click)="editingCanvasTagline = true"
                  class="canvas-clickable-text tagline-text">{{ tagline || 'Enter Tagline (Optional)' }}</span>
                <input *ngIf="editingCanvasTagline" type="text" [(ngModel)]="tagline"
                  (blur)="editingCanvasTagline = false" (keyup.enter)="editingCanvasTagline = false" autofocus
                  class="canvas-inline-input tagline-input" />
              </div>
            </div>

            <!-- Contact block overlay -->
            <div class="canvas-contact-overlay" [style.left.%]="quotationBranding.headerContactLeft"
              [style.top.%]="quotationBranding.headerContactTop" [style.width.%]="quotationBranding.headerContactWidth"
              [style.--theme-color]="quotationBranding.themeColor || '#ffffff'">

              <div class="canvas-contact-row">
                <i class="fa-solid fa-location-dot contact-icon"></i>
                <span *ngIf="!editingCanvasAddress" (click)="editingCanvasAddress = true"
                  class="canvas-clickable-text contact-text">{{ companyAddress || 'Address' }}</span>
                <input *ngIf="editingCanvasAddress" type="text" [(ngModel)]="companyAddress"
                  (blur)="editingCanvasAddress = false" (keyup.enter)="editingCanvasAddress = false" autofocus
                  class="canvas-inline-input contact-input" />
              </div>

              <div class="canvas-contact-row">
                <i class="fa-solid fa-phone contact-icon"></i>
                <span *ngIf="!editingCanvasPhone" (click)="editingCanvasPhone = true"
                  class="canvas-clickable-text contact-text">{{ phoneNumber || 'Phone' }}</span>
                <input *ngIf="editingCanvasPhone" type="text" [(ngModel)]="phoneNumber"
                  (blur)="editingCanvasPhone = false" (keyup.enter)="editingCanvasPhone = false" autofocus
                  class="canvas-inline-input contact-input" />
              </div>

              <div class="canvas-contact-row">
                <i class="fa-solid fa-fax contact-icon"></i>
                <span *ngIf="!editingCanvasFax" (click)="editingCanvasFax = true"
                  class="canvas-clickable-text contact-text">{{ fax || 'Fax' }}</span>
                <input *ngIf="editingCanvasFax" type="text" [(ngModel)]="fax" (blur)="editingCanvasFax = false"
                  (keyup.enter)="editingCanvasFax = false" autofocus class="canvas-inline-input contact-input" />
              </div>

              <div class="canvas-contact-row">
                <i class="fa-solid fa-envelope contact-icon"></i>
                <span *ngIf="!editingCanvasEmail" (click)="editingCanvasEmail = true"
                  class="canvas-clickable-text contact-text">{{ email || 'Email' }}</span>
                <input *ngIf="editingCanvasEmail" type="text" [(ngModel)]="email" (blur)="editingCanvasEmail = false"
                  (keyup.enter)="editingCanvasEmail = false" autofocus class="canvas-inline-input contact-input" />
              </div>

              <div class="canvas-contact-row">
                <i class="fa-solid fa-globe contact-icon"></i>
                <span *ngIf="!editingCanvasWebsite" (click)="editingCanvasWebsite = true"
                  class="canvas-clickable-text contact-text">{{ website || 'Website' }}</span>
                <input *ngIf="editingCanvasWebsite" type="text" [(ngModel)]="website"
                  (blur)="editingCanvasWebsite = false" (keyup.enter)="editingCanvasWebsite = false" autofocus
                  class="canvas-inline-input contact-input" />
              </div>
            </div>
          </ng-container>
        </div>

        <div style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap;">
          <button mat-stroked-button color="primary" (click)="triggerHeaderUpload()" [disabled]="isUploadingHeader"
            style="min-width: 160px;">
            <mat-icon *ngIf="!isUploadingHeader">upload</mat-icon>
            <mat-spinner *ngIf="isUploadingHeader" diameter="20"
              style="display: inline-block; margin-right: 8px; vertical-align: middle;"></mat-spinner>
            {{ (quotationBranding?.headerImageUrl || quotationBranding?.headerBase64) ? 'Replace Header' : 'Upload
            Header' }}
          </button>
          <button *ngIf="quotationBranding?.headerImageUrl || quotationBranding?.headerBase64" mat-stroked-button
            color="warn" (click)="deleteHeader()">
            <mat-icon>delete</mat-icon> Remove
          </button>
          <span style="font-size: 12px; color: #94a3b8; margin-left: auto;">Formats: PNG, JPG, JPEG</span>
        </div>
        <input type="file" id="headerInput" (change)="onHeaderSelected($event)" accept="image/*" hidden />
      </div>

      <!-- Footer Upload Card -->
      <div class="branding-card" *ngIf="activeEditorType === 'footer'"
        style="border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; background: #f8fafc; display: flex; flex-direction: column; gap: 16px;">
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
          <h3 style="margin: 0; font-size: 15px; font-weight: 600; color: #1e293b;">Quotation Footer</h3>
          <span style="font-size: 11px; color: #64748b; font-weight: 500;">Recommended Size: 2480 x 200 px (Aspect ratio
            ~12:1)</span>
        </div>

        <div class="image-preview-box canvas-container"
          style="aspect-ratio: 2480 / 350; width: 100%; border: 1px dashed #cbd5e1; border-radius: 8px; background: #fff; display: flex; align-items: center; justify-content: center; overflow: hidden; position: relative;">
          <img *ngIf="quotationBranding?.footerImageUrl || quotationBranding?.footerBase64"
            [src]="quotationBranding?.footerBase64 || quotationBranding?.footerImageUrl"
            style="width: 100% !important; height: 100% !important; object-fit: fill !important; max-width: none !important; max-height: none !important; position: absolute; top:0; left:0; z-index:1;" />
          <div *ngIf="!(quotationBranding?.footerImageUrl || quotationBranding?.footerBase64)"
            style="color: #94a3b8; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 8px; z-index:2;">
            <mat-icon style="font-size: 32px; height: 32px; width: 32px;">image</mat-icon>
            <span style="font-size: 13px;">No footer uploaded</span>
          </div>

          <!-- Footer Contact Block Overlay -->
          <ng-container
            *ngIf="quotationBranding && (quotationBranding.footerImageUrl || quotationBranding.footerBase64)">
            <div class="canvas-footer-contact-overlay" [style.left.%]="quotationBranding.footerContactLeft"
              [style.top.%]="quotationBranding.footerContactTop"
              [style.width.%]="quotationBranding.footerContactWidth || 45"
              [style.--theme-color]="quotationBranding.themeColor || '#ffffff'">
              <div class="canvas-contact-row">
                <i class="fa-solid fa-location-dot contact-icon"></i>
                <span class="contact-text">{{ companyAddress || 'Address' }}</span>
              </div>
              <div class="canvas-contact-row">
                <i class="fa-solid fa-phone contact-icon"></i>
                <span class="contact-text">{{ phoneNumber || 'Phone' }}</span>
              </div>
              <div class="canvas-contact-row" *ngIf="fax">
                <i class="fa-solid fa-fax contact-icon"></i>
                <span class="contact-text">{{ fax }}</span>
              </div>
              <div class="canvas-contact-row">
                <i class="fa-solid fa-envelope contact-icon"></i>
                <span class="contact-text">{{ email || 'Email' }}</span>
              </div>
              <div class="canvas-contact-row">
                <i class="fa-solid fa-globe contact-icon"></i>
                <span class="contact-text">{{ website || 'Website' }}</span>
              </div>
            </div>
          </ng-container>
        </div>

        <div style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap;">
          <button mat-stroked-button color="primary" (click)="triggerFooterUpload()" [disabled]="isUploadingFooter"
            style="min-width: 160px;">
            <mat-icon *ngIf="!isUploadingFooter">upload</mat-icon>
            <mat-spinner *ngIf="isUploadingFooter" diameter="20"
              style="display: inline-block; margin-right: 8px; vertical-align: middle;"></mat-spinner>
            {{ (quotationBranding?.footerImageUrl || quotationBranding?.footerBase64) ? 'Replace Footer' : 'Upload
            Footer' }}
          </button>
          <button *ngIf="quotationBranding?.footerImageUrl || quotationBranding?.footerBase64" mat-stroked-button
            color="warn" (click)="deleteFooter()">
            <mat-icon>delete</mat-icon> Remove
          </button>
          <span style="font-size: 12px; color: #94a3b8; margin-left: auto;">Formats: PNG, JPG, JPEG</span>
        </div>
        <input type="file" id="footerInput" (change)="onFooterSelected($event)" accept="image/*" hidden />
      </div>
    </div>

    <div
      style="display: flex; justify-content: flex-end; gap: 12px; border-top: 1px solid #e2e8f0; padding-top: 16px; margin-top: 8px;">
      <button mat-button type="button" (click)="dialogRef.close()"
        style="color: #64748b; font-weight: 500;">Cancel</button>
      <button mat-raised-button color="primary" type="button" (click)="saveProfile(); dialogRef.close()"
        [disabled]="isSaving"
        style="background-color: #2563eb; color: #ffffff; font-weight: 600; padding: 6px 20px; border-radius: 8px;">
        Save Changes
      </button>
    </div>
  </div>
</ng-template>